export default {
  building: (state) => state.building,
  buildings: (state) => state.buildings
}



// WEBPACK FOOTER //
// ./src/store/modules/building/getters.js